import BaseEnum from "@/enums/BaseEnum";
import Enum from "@/enums/Enum";


/**
 * 権限区分
 */
export default class KengenKbn extends BaseEnum{
    static KESSAISHA = {value: '01', name: '決裁者', shuriName: '管理者'} as KengenKbnEnum
    static TANTOSHA = {value: '11', name: '担当者', shuriName: 'メン テナンス課(社員・事務員）'} as KengenKbnEnum
    static TORIHIKISAKI_SEKININSHA  = {value: '51', name: '取引先（責任者）', shuriName: '取引先（責任者）'} as KengenKbnEnum
    static TORIHIKISAKI_TANTOSHA = {value: '61', name: '取引先（担当者）', shuriName: '取引先（担当者）'} as KengenKbnEnum
    static SHANAI_ETSURAN = {value: '71', name: '社内閲覧者', shuriName: '社内閲覧者'} as KengenKbnEnum
}
export interface KengenKbnEnum extends Enum{
	shuriName: string
}
KengenKbn.values = [KengenKbn.KESSAISHA, KengenKbn.TANTOSHA, KengenKbn.TORIHIKISAKI_SEKININSHA , KengenKbn.TORIHIKISAKI_TANTOSHA, KengenKbn.SHANAI_ETSURAN]
